import "components/ui/NotificationBar/NotificationBar.scss";

function NotificationBar({ children }) {

  return (
    <div className={ 'notification-bar-container' }>
      <div className={ 'wrapper--fluid notification-bar' }>
        { children }
      </div>
    </div>
  )
}

export default NotificationBar;
